/**
 * @license
 * Copyright Tyler Technologies, Inc. 
 * License: Apache-2.0
 */
import { defineCustomElement } from '@tylertech/forge-core';
import { ToastComponent } from './toast';
export * from './toast-adapter';
export * from './toast-constants';
export * from './toast-core';
export * from './toast';
export function defineToastComponent() {
    defineCustomElement(ToastComponent);
}
